// Firebase configuration updated for modern Firebase v10 with TypeScript
import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'
import { serverTimestamp, deleteField } from 'firebase/firestore'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyBulM_w6kdO4bUvh0MhWY_6xLjGbwDUWlQ",
  authDomain: "shelf-backend.firebaseapp.com",
  databaseURL: "https://shelf-backend.firebaseio.com",
  projectId: "shelf-backend",
  storageBucket: "shelf-backend.appspot.com",
  messagingSenderId: "720001570562",
  appId: "1:720001570562:web:4ada3d2d996d42a1",
  measurementId: "G-1X8N4W3PN9"
}

export const firebaseApp = initializeApp(config)
// Firestore's modern cache API coordinates IndexedDB access between tabs and
// keeps locally acknowledged writes queued until connectivity returns.
export const firestore = (() => {
  try {
    return initializeFirestore(firebaseApp, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    })
  } catch (error) {
    // This can happen in browsers without IndexedDB or when another module
    // initialized Firestore first. Keep the app usable with the SDK fallback.
    console.warn('Modern Firestore persistence unavailable; using default cache.', error)
    return getFirestore(firebaseApp)
  }
})()
export const auth = getAuth(firebaseApp)
export const storage = getStorage(firebaseApp)
export const functions = getFunctions(firebaseApp)

// Firebase utilities
export const FieldValue = {
  serverTimestamp,
  delete: deleteField
}

export default firebaseApp
